module.exports = __webpack_public_path__ + "turn_off_active.png?4db41ba71892e8a35a9fb024d3f5b257";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/turn_off_active.png
// module id = 1018
// module chunks = 2